import { CandidateApplicationStatus } from "@/types";

const statusColorMap: Record<
  CandidateApplicationStatus,
  { dotColor: string; textColor: string; backgroundColor: string }
> = {
  Identified: {
    dotColor: "bg-red-600",
    backgroundColor: "bg-red-100",
    textColor: "text-red-600",
  },
  "Initial Outreach": {
    dotColor: "bg-red-600",
    backgroundColor: "bg-red-100",
    textColor: "text-red-600",
  },
  "Not Interested": {
    dotColor: "bg-red-600",
    backgroundColor: "bg-red-100",
    textColor: "text-red-600",
  },
  "Checking Interest": {
    dotColor: "bg-pink-600",
    backgroundColor: "bg-pink-100",
    textColor: "text-pink-600",
  },
  Screening: {
    dotColor: "bg-orange-600",
    backgroundColor: "bg-orange-100",
    textColor: "text-orange-600",
  },
  "Possible Fit": {
    dotColor: "bg-blue-600",
    backgroundColor: "bg-blue-100",
    textColor: "text-blue-600",
  },
  Shortlisted: {
    dotColor: "bg-purple-600",
    backgroundColor: "bg-purple-100",
    textColor: "text-purple-600",
  },
  "Making Offer": {
    dotColor: "bg-yellow-600",
    backgroundColor: "bg-yellow-100",
    textColor: "text-yellow-600",
  },
  Contracting: {
    dotColor: "bg-lime-600",
    backgroundColor: "bg-lime-100",
    textColor: "text-lime-600",
  },
  "Accepted by Client": {
    dotColor: "bg-green-600",
    backgroundColor: "bg-green-100",
    textColor: "text-green-600",
  },
  "Rejected for Role": {
    dotColor: "bg-violet-600",
    backgroundColor: "bg-violet-100",
    textColor: "text-violet-600",
  },
};

const jobCandidateStatusToColors = (status?: CandidateApplicationStatus) =>
  statusColorMap[status ?? "Rejected for Role"];

export default jobCandidateStatusToColors;
